export default function AssessmentDocumentDirective() {
  return {
    template: require('./assessment-document.html'),
    scope: {
      assessmentId: '=',
      assessment: '=',
      canEdit: '=',
      canDelete: '=',
      assessmentDocument: '=',
    },
    controller: 'BCPAssessmentDocumentController',
    controllerAs: 'assessmentDocumentVM',
    bindToController: true,
    replace: true
  };
}
